import { UploadedFileInfoSection } from "./UploadedFileInfoSection";

export default UploadedFileInfoSection;
